import { createSlice } from '@reduxjs/toolkit'



const initialState = {
    taxonomyBatchId: "",
    taxonomyDataPath: {},
    taxonomyDescription: "",
    taxonomyProgress: 0,
    taxonomyTotal: 0,
    taxonomyStatus: "Init",
    taxonomyCreatedTs: "",
}



export const taxonomyBatchSlice = createSlice({
    name: 'taxonomyBatch',
    initialState,
    reducers: {
        addTaxonomyBatch: (state, action) => {
            if (action.payload && action.payload.id) {
                const res = action.payload;
                state.taxonomyBatchId = res.id;
                state.taxonomyDescription = res.description;
                state.taxonomyProgress = res.progress;
                state.taxonomyTotal = res.total;
                state.taxonomyStatus = res.status;
                state.taxonomyCreatedTs = res.createdTs;

                const paths = action.payload.dataPath.split(',');
                state.taxonomyDataPath.individual = paths[0];
                state.taxonomyDataPath.nonIndividual = paths[1];
            }
        },
        resetTaxonomyBatch: () => initialState,
    }
})


export const { addTaxonomyBatch, resetTaxonomyBatch } = taxonomyBatchSlice.actions;

export default taxonomyBatchSlice.reducer;